// @ts-nocheck
import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, CardHeader, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useChart } from '../chart';
import { UserAccessTrend } from './types';

interface UserAccessTrendChartProps {
  title: string;
  subheader?: string;
  data: UserAccessTrend[];
}

export default function UserAccessTrendChart({ title, subheader, data }: UserAccessTrendChartProps) {
  const theme = useTheme();

  const chartLabels = data.map((d) => d.date);
  const chartSeries = [
    { name: 'Users with Access', data: data.map((d) => d.usersWithAccess) },
    { name: 'Active Users', data: data.map((d) => d.activeUsers) },
  ];

  const chartOptions = useChart({
    labels: chartLabels,
    colors: [theme.palette.info.main, theme.palette.success.main],
    xaxis: { type: 'datetime' },
    stroke: { width: [3, 3], curve: 'smooth' },
    fill: {
      type: ['solid', 'gradient'],
      opacity: [0.1, 0.3],
      gradient: { shadeIntensity: 1, opacityFrom: 0.4, opacityTo: 0.1, stops: [0, 100] },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: { formatter: (val) => `${val} users` },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
    },
  });

  return (
    <Card>
      <CardHeader title={title} subheader={subheader} />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart type="area" series={chartSeries} options={chartOptions} height={320} />
      </Box>
    </Card>
  );
}
